<template>
  <div class="cx-icon">
    <img :src="require(`@assets/images/icon/${normal}`)" v-show="!isActive">
    <img :src="require(`@assets/images/icon/${active}`)" v-show="isActive" class="activeImg">
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  },
  props: {
    normal: {
      type: String,
      default: '1.png'
    },
    active: {
      type: String,
      default: '1-1.png'
    },
    isActive: {
      type: Boolean,
      default: false
    }
  },
}
</script>
<style scoped lang="stylus">
.cx-icon
  width 20px
  height 20px
  position relative
  img
    width 100%
  .activeImg
    position absolute 
    top 50%
    left 50%
    transform translate3d(-50%, -50%, 0)
    animation show .5s ease forwards
@keyframes show 
  0%
    width 0
    height 0
  90%
    width 110%
    height 110%
  100%
    width 100%
    height 100%
</style>